import { useEffect, useState } from 'react';
import { EMITTER_CONSTANTS, ROOM_FACILITY } from '@/shared/config';
import { auth } from '@/shared/lib';
import socketio from '@/shared/lib/socketio';
import { useEmitter } from '@/shared/lib/customHooks';

/**
 * Bootstraps the main layout's realtime connection and tracks whether the page has crashed. A mount effect joins the facility and per-user socket rooms, and a subscription to the page-crashed emitter event latches a flag the layout renders a fallback from.
 *
 * @returns An object exposing isPageCrashed.
 */
const useMain = () => {
  const [isPageCrashed, setIsPageCrashed] = useState(false);

  /**
   * Joins the realtime rooms the signed-in user needs for facility and per-user notifications. Two room emits are issued on the socket, one for the shared facility room and one keyed by the authenticated user id.
   *
   * @returns A promise resolving once both room emits have been issued.
   */
  const connectSocket = async () => {
    socketio.emitRoom(ROOM_FACILITY.FACILITY_ROOM);
    socketio.emitRoom(`airp-user-${auth.userId()}`);
  };

  useEffect(() => {
    // *: Connect socket IO
    connectSocket();
  }, []);

  useEmitter(
    EMITTER_CONSTANTS.PAGE_CRASHED,
    () => {
      setIsPageCrashed(true);
    },
    [],
  );

  return { isPageCrashed };
};

export default useMain;
